import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Subject } from 'rxjs';

import { MenuChangeEvent } from '../interfaces/menuchangeevent';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private menuSource = new Subject<MenuChangeEvent>();
  private resetSource = new Subject();
  menuSource$ = this.menuSource.asObservable();
  resetSource$ = this.resetSource.asObservable();

  onMenuStateChange(event: MenuChangeEvent) {
    this.menuSource.next(event);
  }

  reset() {
    this.resetSource.next(true);
  }

  getMenuItemsByRoles() {
    return this.getMenuItems(); //filter by roles later
  }

  private getMenuItems(): MenuItem[] {
    return [
      {
        label: 'Izvještaji',
        roles: [],
        items: [
          {
            label: 'Pomoć',
            icon: 'pi pi-fw pi-user',
            routerLink: ['/'],
          },
        ],
      },
      {
        label: 'Primatelji pomoći',
        roles: [],
        items: [
          {
            label: 'Popis',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/aid-recipients'],
          },
          {
            label: 'Tipovi primatelja',
            icon: 'pi pi-fw pi-id-card',
            routerLink: ['/aid-recipient-types'],
          },
          {
            label: 'Kategorije primatelja',
            icon: 'pi pi-fw pi-tags',
            routerLink: ['/aid-recipient-categories'],
          },
          {
            label: 'Grupe primatelja',
            icon: 'pi pi-fw pi-sitemap',
            routerLink: ['/aid-recipient-groups'],
          },
        ],
      },
      {
        label: 'Pomoć',
        roles: [],
        items: [
          {
            label: 'Izdana pomoć',
            icon: 'pi pi-fw pi-info-circle',
            routerLink: ['/issue-aid'],
          },
          {
            label: 'Izdaj pomoć grupi',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/issue-aid/group-issue'],
          },
          {
            label: 'Zaprimljena pomoć',
            icon: 'pi pi-fw pi-info-circle',
            routerLink: ['/received-aid'],
          },
          {
            label: 'Tip pomoći',
            icon: 'pi pi-fw pi-box',
            routerLink: ['/aid-types'],
          },
          {
            label: 'Mjerne jedinice',
            icon: 'pi pi pi-hashtag',
            routerLink: ['/metrics'],
          },
        ],
      },
      {
        label: 'Donatori pomoći',
        roles: [],
        items: [
          {
            label: 'Popis',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/aid-donors'],
          },
          {
            label: 'Tip donatora',
            icon: 'pi pi-fw pi-id-card',
            routerLink: ['/aid-donor-types'],
          },
        ],
      },
    ];
  }
}
